export function FanIcon({ size = 35, className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      color="white"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      width={size}
      height={size}
      className={className}
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="1.5" />
      <path d="M12 3.8l2.6 6.2" />
      <path d="M20.2 12l-6.2 2.6" />
      <path d="M12 20.2l-2.6-6.2" />
      <path d="M3.8 12l6.2-2.6" />
    </svg>
  );
}